import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import {MailMessage, GmailImportMailMessage} from 'api';
import addrs from 'email-addresses';

interface GmailImport extends MailMessage {
  messageable: GmailImportMailMessage;
}

interface Props {
  mailMessage: GmailImport;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default ({mailMessage, open, setOpen}: Props) => {
  const {gmailMessage} = mailMessage.messageable;
  const toggleOpen = React.useCallback(() => setOpen(!open), [open, setOpen]);

  const sender = React.useMemo(() => {
    const addr: any = addrs.parseOneAddress(gmailMessage.fromAddress);
    return (
      <div>
        {addr.name || addr.local} <span>&lt;{addr.address}&gt;</span>
      </div>
    );
  }, [gmailMessage]);

  return (
    <Container>
      <h4 onClick={toggleOpen}>
        <div>{sender}</div>
        <span>{moment(gmailMessage.sendAt).format('YYYY/MM/DD HH:mm')}</span>
      </h4>
      {open ? (
        <Message dangerouslySetInnerHTML={{__html: gmailMessage.bodyHtml}} />
      ) : (
        <Snippet onClick={toggleOpen}>{gmailMessage.bodyPlain}</Snippet>
      )}
    </Container>
  );
};

const Container = styled.div`
  border-bottom: solid 1px var(--border-color);
  padding: 1rem 0;

  h4 {
    font-size: 14px;
    font-weight: bold;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    div {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span {
      font-size: 12px;
      color: var(--text-color-2);
      font-weight: normal;
    }
  }
`;

const Message = styled.div`
  padding: 1rem 0;
  * {
    max-width: 100% !important;
    overflow-x: hidden !important;
  }
  img {
    height: auto !important;
  }
`;

const Snippet = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
`;
